<section *ngIf='show' style="padding: 20px;padding-top: 0px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12 mt-3">
        <div class="card">
            <div class="card-header choose3">
                <h4 style="display:inline-block;">Quotations : </h4>
                <button *ngIf='add' (click)='addS0C("as")' style="box-shadow:none; display: inline-block; border: 1px solid black;height:27px;line-height:0;" type="button" class="btn btn-secondary ml-2">Add New QUotation</button>
                <button *ngIf='add' (click)='addCustomer()' style="box-shadow:none; border: 1px solid black;height:27px;line-height:0;" type="button" class="btn btn-secondary ml-1">Add Customer</button>
                <button (click)='ref()' style="box-shadow:none;border: 1px solid black;height:27px;line-height:0;" type="button" class="btn btn-success ml-1"><i class="fas fa-sync-alt"></i></button>
                <button title="Delete Quotation" (click)='deleteall00()' style="box-shadow:none;border: 1px solid black; float:right;height:27px;line-height:0;" type="button" class="btn btn-danger ml-1 delall"><i class="fas fa-trash-alt"></i></button>
                <button title="Return Money" (click)='returnback()' style="box-shadow:none;border: 1px solid black; float:right;height:27px;line-height:0;" type="button" class="btn btn-dark ml-1 delall"><i class="fas fa-undo"></i></button>
                <button title="Print Quotation" (click)='printall()' style="box-shadow:none;border: 1px solid black; float:right;height:27px;line-height:0;" type="button" class="btn btn-success ml-1 delall"><i class="fas fa-print"></i></button>
                <span style="clear:both"></span>
                <div class='container-fluid'>
                    <div class="row">
                        <div class="col-lg-3">
                            <div class='mt-1 pl-1 lastU'>
                                <select [(ngModel)]='customer_id' name="customer_id" class="form-control mt-4 sO submitNumber select2 goQN" style="height: unset !important;">
                              <option value="undefined" disabled>Customer</option>
                              <option *ngFor='let r of arreCustomer' [value]="r.id">{{r.name}}</option>
                              </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-4 col-12 p-1">
                            <span style=' display: none !important;'>
                            <select [(ngModel)]='Customer' class="form-control select2 select2QC" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;" disabled>
                          <option disabled>Customer</option>
                          <option *ngFor='let x of arreCustomer' [value]="x.id">{{x.name}}</option>
                  </select>
                </span>
                            <form class='nog5 yaa5y0' #data124009='ngForm' (submit)='okUpAnother(data124009.value)' style="direction: ltr !important;border:1px solid black">
                                <span id="form00" style="display: block;">
                                  <fieldset>
                                    <legend class='ml-2'>Customer Details</legend>
                                  <div class='container-fluid pl-1 pr-1'>
                                    <div class='row'>
                                      <div class='col-12'>
                                        <input style='border-color: black !important;width: 96.8% !important;' class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
                                      </div>
                                      <div class='col-12'>
                                        <input style='border-color: black !important;width: 96.8% !important;' class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Adress" required="">
                                      </div>
                                      <div class='col-6'>
                                        <input style='border-color: black !important;' class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
                                      </div>
                                      <div class='col-6'>
                                        <input style='border-color: black !important;' class="text mt-2 d1" type="text" name="emailU" [(ngModel)]='emailU' placeholder="Email" required="">
                                      </div>
                                      <div class='col-6'>
                                        <select [(ngModel)]='typeU' name="typeU" class="form-control mt-2" style="height: 25px !important; width: 100%; color: black !important;border:1px solid black !important;padding:0 !important;text-align-last: center;">
                                          <option disabled selected value="">Type</option>
                                          <option>Normal</option>
                                          <option>Family</option>
                                          <option>Vip</option>
                                          <option>Project</option>
                                  </select></div>
                                      <div *ngIf='upS' class='col-6'>
                                        <input class="mt-2" style="width: 94.5% !important;float: left;color: white !important;line-height: 0;padding: 11.5px;" type="submit" value="Update">
                                      </div>
                                      <div *ngIf='upS0' class='col-6'>
                                        <input *ngIf='add' (click)='addS0(data124009.value)' class="mt-2" style="width: 94.5% !important;float: left;color: white !important;line-height: 0;padding: 11.5px;" type="button" value="Add">
                                      </div>
                                    </div>
                                  </div>
                          <div style="clear: both;"></div>
                        </fieldset>
                    </span>
                            </form>
                            <form class='nog5 mt-2 kkloi pb-2 yaa5y0' style="direction: ltr !important;border:1px solid black">
                                <span id="form00" style="display: block;">
                        <fieldset>
                          <legend class='ml-2'>Seller Details</legend>
                        <div class='container-fluid pl-1 pr-1'>
                          <div class='row'>
                            <div class='col-6 mb-2'>
                              <select [(ngModel)]='nameUX' name="nameUX" class="form-control mt-4 sO submitNumber select2 goQN00">
                                <option value="undefined" disabled>Seller</option>
                                <option value="null">No</option>
                                <option *ngFor='let r of arreCustomer00' [value]="r.id">{{r.name}}</option>
                                </select> </div>
                          </div>
                        </div>
                <div style="clear: both;"></div>
              </fieldset>
          </span>
                            </form>

                        </div>
                        <div class="col-lg-4 col-12">
                            <form class='nog5 kkloi mt-2 pb-2 yaa5y0' style="direction: ltr !important;border:1px solid black;">
                                <span id="form00" style="display: block;">
      <fieldset>
        <legend class='ml-2'>Broker</legend>
      <div class='container-fluid pl-1 pr-1'>
        <div class='row'>
          <div class='col-6 mb-2'>
            <select [(ngModel)]='nameUX0' name="nameUX0" class="form-control mt-4 sO submitNumber select2 goQN00X0" style="height: unset !important;">
              <option value="undefined" disabled>Broker</option>
              <option value="null">No</option>
              <option *ngFor='let r of arreCustomer000' [value]="r.id">{{r.name}}</option>
              </select>                      </div>
              <div class='col-6 mb-2' style='text-align: right;'>
                <button (click)='addS0C("as")' style="box-shadow:none;" type="button" class="btn btn-danger ml-1 yaa5y00">Confirmation of addition</button>
              </div>
              <form class='nog5 yaa5y0 mt-2' #data1240099='ngForm' (submit)='okUpB(data1240099.value)' style="direction: ltr !important;border:1px solid black">
                <span id="form00" style="display: block;">
                  <fieldset>
                    <legend class='ml-2'>Broker Details</legend>
                  <div class='container-fluid pl-1 pr-1'>
                    <div class='row'>
                      <div class='col-6'>
                        <input style='border-color: black !important;' class="text mt-2 d1" type="text" name="nameU0" [(ngModel)]='nameU0' placeholder="Name" required="">
                      </div>
                      <div class='col-6'>
                        <input style='border-color: black !important;' class="text mt-2 d1" type="number" name="phoneU0" [(ngModel)]='phoneU0' placeholder="Phone" required="">
                      </div>
                  <div class='col-6'>
                    <label class="mt-2">Commision_Percentage</label>
                    <input (blur)='changeDis01()' style='border-color: black !important;' class="text d1" type="text" name="commision" [(ngModel)]='commision' placeholder="Commision Percentage" required="">
                  </div>
                  <div class='col-6'>
                    <label class="mt-2">Commision_Value</label>
                    <input (blur)='changeDis02()' style='border-color: black !important;' class="text d1" type="text" name="commisionafter" [(ngModel)]='commisionafter' placeholder="Commision Value" required="">
                  </div>
                      <div *ngIf='upS' class='col-6'>
                        <input class="mt-2" style="width: 94.5% !important;float: left;color: white !important;line-height: 0;margin-bottom: 9px !important" type="submit" value="Update">
                      </div>
                      <div class='col-6' *ngIf='add'>
                        <input (click)='addS0G(data1240099.value)' class="mt-2" style="width: 94.5% !important;float: left;color: white !important;line-height: 0; margin-bottom: 9px !important;padding:5px !important;" type="button" value="Add">
                      </div>
                    </div>
                  </div>
          <div style="clear: both;"></div>
        </fieldset>
    </span>
                            </form>
                        </div>
                    </div>
                    <div style="clear: both;"></div>
                    </fieldset>
                    </span>
                    </form>
                </div>
                <div class="col-lg-4 col-12 p-1 kkloi nog5">
                    <form class='yaa5y0' style="direction: ltr !important;border:1px solid black">
                        <span id="form00" style="display: block;">
      <fieldset>
        <legend class='ml-2'>Invoice Info</legend>
      <div class='container-fluid pb-1 pl-1 pr-1'>
        <div class='row'>
          <div class='col-6 mb-2'>
            <select [(ngModel)]='QUotationNo' class="form-control select2 select2Q" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
              <option value='undefined' disabled selected>QUotation No</option>
              <option *ngFor='let x of arre|customerId:yarbs' [value]="x.id">{{x.id}}</option>
      </select>
      </div>
  <div class='col-6 mb-2'>
    <input id='goDate' style='border-color: black !important; width: 96% !important;'  class="text d1" type="date" name='dateAm' [value]='dateAm| date:"yyyy-MM-dd"' placeholder="Date" required="">
  </div>
  <div class='col-6 mb-2'>
    <label>Total_amount</label>
    <input style='border-color: black !important;'  class="text d1" type="number" name='alltotal' [(ngModel)]='alltotal' placeholder="Total amount" required="" disabled>
  </div>
<div class='col-6 mb-2'>
  <label>Total_after_Discound</label>
  <input style='border-color: black !important;'  class="text d1" type="number" name='payAll00' [(ngModel)]='payAll00' placeholder="Total after Discound" required="" disabled>
</div>
<div class='col-6 mb-2'>
  <label>Discound_Value</label>
  <input (blur)='changeDis0()' style='border-color: black !important;'  class="text d1" type="number" name='discoundAllValue' [(ngModel)]='discoundAllValue' placeholder="Discound Value" required="">
</div>
<div class='col-6 mb-2'>
  <label>Discound_Percentage</label>
  <input (blur)='changeDis01()' style='border-color: black !important;'  class="text d1" type="number" name='discoundAll' [(ngModel)]='discoundAll' placeholder="Discound Percentage" required="">
</div>
<div class='col-6 mb-2'>
  <label>Down_Payment</label>
  <input style='border-color: black !important;'  class="text d1" type="number" name='payAll' [(ngModel)]='payAll' placeholder="Down Payment" required="" disabled>
</div>
<div class='col-6 mb-2'>
  <label>The_Remaining</label>
  <input style='border-color: black !important;'  class="text d1" type="number" name='payAllSUB' [(ngModel)]='payAllSUB' placeholder="The_Remaining" required="" disabled>
</div>
<div class='col-6'>
  <input id='gotohill' (click)='upN5()' class="mt-2" style="margin-bottom:5px !important;width: 94.5% !important;float: left;color: white !important;line-height: 0;" type="submit" value="Update">
</div>
<div class='col-6'>
  <input id='payNew' (click)='items0("l")' class="mt-2" style="margin-bottom:5px !important;width: 94.5% !important;float: left;color: white !important;line-height: 0;" type="submit" value="Pay">
</div>
<div class='col-6' *ngIf='add'>
  <input (click)='up00000d()' class="mt-2 delall" style="margin-bottom:5px !important;width: 94.5% !important;float: left;color: white !important;line-height: 0;background-color: red !important;" type="submit" value="Order">
</div>
<div class='col-6 mb-2'>
  <label>Delivery_Date</label>
  <input
    style='border-color: black !important; width: 96% !important;'
    class="text d1"
    type="date"
    name="delivery_date"
    [(ngModel)]="delivery_date"
    placeholder="Delivery Date">
</div>
        </div>
      </div>
<div style="clear: both;"></div>
</fieldset>
</span>
                    </form>
                </div>

            </div>
        </div>
    </div>

    <div class="card-body" style="padding: 0 !important; display:none !important">
        <div class="table-responsive" style="overflow: auto;">


            <div class="container" style="margin: 0 !important;max-width:100% !important;">
                <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                    <thead>
                        <tr>
                            <th>Number</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Phone 2</th>
                            <th scope="col">City</th>
                            <th scope="col">Adress</th>
                            <th scope="col">Date</th>
                            <th scope="col" *ngIf='update'>Update</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor='let v of arreCustomer|searchName:searchName|serchCodeSupplier:serchCodeVisit; let n = index;'>
                            <th scope="row">{{n+1}}</th>
                            <td data-title="Name">{{v.name}}</td>
                            <td data-title="Email">{{v.email}}</td>
                            <td data-title="Phone">0{{v.phone}}</td>
                            <td data-title="Phone">0{{v.phone2}}</td>
                            <td data-title="City">{{v.city}}</td>
                            <td data-title="Adress">{{v.adress}}</td>
                            <td data-title="Date">{{v.date}}</td>
                            <td data-title="Update" *ngIf='update'><button id='ostr' (click)='upUAnother(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div id='fdgh' class='col-12 choose3' style='background-color: #292929;'>
        <form id='upd-up00' #datadf4='ngForm' (submit)='addS0CB(datadf4.value)' style="direction: ltr !important;">
            <span id="form00" style="display: block;">
              <ng-container *ngIf='goQty0'>
              </ng-container>
              <div class='container-fluid pl-1 pr-1'>
                <div class='row'>
                  <div class='col-sm-5 lastU'>
                    <label style='color: white;'>Items :</label>
                    <select [(ngModel)]='items' name="items" class="form-control mt-4 sO submitNumber select2 selectPlus col-3" style="height: unset !important;">
                      <option value='undefined' disabled>Items</option>
                      <option *ngFor='let r of allI|itemmin0' [value]="r.id">{{r.code}}  ||  {{r.rootname}}</option>
                      </select>
                  </div>
                  <div class='col-sm-3 lastU' style='display: none;'>
                    <label style='color: white;'>Branches :</label>
                    <select [(ngModel)]='rootB' name="rootB" class="form-control mt-4 sO submitNumber select2 selectPlusR" style="height: unset !important;display: inline-block;">
                      <option [value]='undefined' disabled>Branches</option>
                      <option *ngFor='let r of QtyAvaliable|itemmin0' [value]="r.place">{{r.rootname}}</option>
                      </select>
                  </div>
                  <div class='col-sm-3'>
                    <label style='color: white;'>Qty :</label>
                    <input style='width: 94.5% !important;height: 27px;display: inline-block;' class="text d1 submitNumber mb-2" type="number" name="qty" [(ngModel)]='qty' [placeholder]="ost" required="">
                  </div>
                  <div class='col-sm-3'>
                    <label style='color: white;'>Price Seller :</label>
                    <input style='width: 94.5% !important;height: 27px;display: inline-block;' class="text d1 submitNumber mb-2" type="number" name="priceSeller" [(ngModel)]='priceSeller' [placeholder]="priceSeller" required="">
                  </div>
                  <div class="col-sm-1 mt-4">
                    <button style='margin-top: auto; width:100%;line-height:1;padding: 4px !important;' class='btn btn-secondary' type="submit"><i class="fas fa-plus"></i></button>
                  </div>
                  </div>
              </div>
      <div style="clear: both;"></div>
      </span>
        </form>
        <form id='upd-up0' #data09oiu00='ngForm' (submit)='okUp0(data09oiu00.value)' style="direction: ltr !important;">
            <span id="form00" style="display: block;">
                      <div class='container-fluid pl-1 pr-1'>
                        <div class='row'>
                      <div class='col-sm-3'>
                        <label style='color: white;'>Qty :</label>
                        <input style='width: 94.5% !important;height: 25px;display: inline-block;' class="text d1 submitNumber mb-2" type="number" name="qty" [(ngModel)]='qty' placeholder="Qty" required="">

                      </div>
                      <div class='col-sm-3'>
                        <label style='color: white;'>price Seller :</label>
                        <input style='width: 94.5% !important;height: 25px;display: inline-block;' class="text d1 submitNumber mb-2" type="number" name="priceSeller" [(ngModel)]='priceSeller' placeholder="price Seller" required="">
                      </div>
            <div class="col-sm-1 mt-4">
              <button style='margin-top: auto; width:100px;line-height:1;padding: 4.5px;' class='btn btn-secondary' type="submit"><i class="fas fa-edit"></i></button>
          </div>
              <div style="clear: both;"></div>
              </div>
              </div>
        </span>
        </form>
    </div>
    <div class='container-fluid choose2'>
        <div class='row'>
            <div class='col-6' style='text-align: center;'>
                <img src='../../assets/video/04377946-bbde-4742-9bef-95d6a362cc0c.jpg'>
            </div>
            <div class="col-6" style='text-align: center;'>
                <h2 style="display: inline-block;">DATE : </h2> {{date}}<br>
                <h2 style="display: inline-block;">Quotation No . </h2> {{quota}}<br>
                <h2 style="display: inline-block;">Delivery Date : </h2> {{delivery_date | date:'dd-MM-yyyy'}}<br>
            </div>
            <div class="col-6" style='text-align: center;'>
                <div class="card border-light mb-3" style="max-width: 18rem;border:1px solid #80808091 !important;text-align: left;display: inline-block;">
                    <div class="card-header" style='text-align:center;background-color:#80808091; color:black;font-weight:bolder;padding: 0;'>SERVICE PROVIDER</div>
                    <div class="card-body">
                        <h5 class="card-title mb-1">El Shikh Zayed - 2nd Entance - Area 6 - City Mark Mall</h5>
                        <h5 class="card-text">Tel : 0238519333 - 0238519444</h5>
                        <h5 class="card-text">Mobil : 01222222712</h5>
                        <h5 href='www.nogal-furniture.com' style='font-weight: bolder;color: blue;'>www.nogal-furniture.com</h5>
                    </div>
                </div>
            </div>
            <div class="col-6" style='text-align: center;'>
                <div class="card border-light mb-3" style="max-width: 18rem;border:1px solid #80808091 !important;text-align: left;display: inline-block;">
                    <div class="card-header" style='text-align:center;background-color:#80808091; color:black;font-weight:bolder;padding: 0;'>CUSTOMER</div>
                    <div class="card-body">
                        <h5 class="card-title mb-1">Name : {{nameU}}</h5>
                        <h5 class="card-text">Adress : {{adressU}}</h5>
                        <h5 class="card-text">Phone : {{phoneU}}</h5>
                        <h5 class="card-text">Email : {{emailU}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <a id='parentDelete' style='overflow: auto;height: 40vh;width:100%;'>

        <table id='parentDelete1' class="responsive-table" style="border-collapse: separate;border-spacing: 0;page-break-inside:auto;" width="100%">
            <thead>
                <tr>
                    <th scope="col" class='choose3'><i class="fas fa-check"></i></th>
                    <th style="text-align: center;" class='choose3'>No.</th>
                    <th scope="col">Photo</th>
                    <th scope="col" class='choose3'>Item_Code</th>
                    <th scope="col" class='choose3'>Branch</th>
                    <th scope="col">Description</th>
                    <!-- <th scope="col">Finishing/fabrics</th> -->
                    <th scope="col">Dimensions</th>
                    <th scope="col" class='choose3'>Current_Price</th>
                    <th scope="col">Qty</th>
                    <th scope="col" class='choose3'>Current_Total_Coast</th>
                    <th scope="col">{{Price_Seller}}</th>
                    <th scope="col">Net_Amount</th>
                    <th scope="col" class='choose3'>Update</th>
                    <th scope="col" class='choose3'>Cancel</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor='let v of arre00|itemmin0; let n = index;'>
                    <th scope="row" style="text-align: center;" class='choose3'><input type="checkbox"></th>
                    <th scope="row" style="text-align: center;" class='choose3'>{{n+1}}</th>
                    <td data-title="Photo">
                        <img (click)='showpho(v.id_item)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:70px;height:70px;cursor: pointer;' [src]='(v.url != null) ? v.url : "../../assets/video/noimage.jpg" '>
                    </td>
                    <td data-title="Item_Code" class='choose3'>{{v.itemcode}}</td>
                    <td data-title="Branch" class='choose3'>{{v.rootname}}</td>
                    <td data-title="Description">
                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                    </td>
                    <!-- <td data-title="Finishing/fabrics">
                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.fabric}}</a></div>
                    </td> -->
                    <td data-title="Dimensions">
                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.dimensions}}</a></div>
                    </td>
                    <td data-title="Current_Price" class='choose3'>{{v.price}}</td>
                    <td data-title="Qty">{{v.qty}}</td>
                    <td data-title="Current_Total_Coast" class='choose3'>{{v.price * v.qty}}</td>
                    <td data-title="{{Price_Seller}}">{{v.priceSeller}}</td>
                    <td data-title="Net_Amount" class='prinee'>{{v.total}}</td>
                    <td data-title="Update" class='choose3'><button (click)='upU0(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                    <td data-title="Cancel" class='choose3'><i (click)='delS(v.id, v.itemcode , v.qty , v.id_item , v.priceSeller)' class="fas fa-times m-4" style="cursor: pointer;"></i></td>

                </tr>
                <tr *ngIf='choose2' style='background-color:white !important;page-break-inside:avoid; page-break-after:auto'>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>

                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td data-title="TOTAL" style="text-align: right; font-weight: bolder;border: 0 !important;">TOTAL : </td>
                    <td data-title="TOTAL">{{alltotal}}</td>
                </tr>
                <ng-container *ngIf='discoundAllValue > 0'>
                    <tr *ngIf='choose2' style='background-color:white !important;page-break-inside:avoid; page-break-after:auto'>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td data-title="Special Discount" style="text-align: right;font-weight: bolder;border: 0 !important;">Special Discount : </td>
                        <td data-title="Special Discount">{{discoundAllValue}}</td>
                    </tr>
                </ng-container>
                <ng-container *ngIf='discoundAllValue > 0'>
                    <tr *ngIf='choose2' style='background-color:white !important;page-break-inside:avoid; page-break-after:auto'>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">TOTAL After Dis : </td>
                        <td data-title="TOTAL After Dis">{{payAll00}}</td>
                    </tr>
                </ng-container>
                <ng-container *ngIf='choose2'>

                    <tr *ngFor='let v of arre0987; let n = index;' style='background-color:white !important;page-break-inside:avoid; page-break-after:auto'>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">{{v.date|date:'dd-MM-yyyy'}} </td>
                        <td data-title="TOTAL After Dis">{{v.money}}</td>
                    </tr>
                </ng-container>
                <tr *ngIf='choose3' style='background-color:white !important;page-break-inside:avoid; page-break-after:auto'>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">Total Payed : </td>
                    <td data-title="TOTAL After Dis">{{payAll}}</td>
                </tr>
                <tr *ngIf='choose3' style='background-color:white !important;page-break-inside:avoid; page-break-after:auto'>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">Remaining : </td>
                    <td data-title="TOTAL After Dis">{{payAll00 - payAll}}</td>
                </tr>
            </tbody>
        </table>
    </a>
    <p *ngIf='choose2' style="font-size: 17px;font-weight: bolder;" class='mt-4'>Noticeable : ‐</p>
    <p *ngIf='choose2' style="font-size: 17px;">* Prices doesn't include VAT or any other taxes.</p>
    <p *ngIf='choose2' style="font-size: 17px;">* This offer includes supply and installation</p>
    <p *ngIf='choose2' style="font-size: 17px;">* This offer is valid for one week.</p>
    <p *ngIf='choose2' class="mt-3" style="font-size: 17px;font-weight: bolder;text-align: center;color: black;">THANK YOU</p>
    <img class='shadow-lg' *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>



    </div>
    </div>
    <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addS0C(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">

            <select [(ngModel)]='customer_id' name="customer_id" class="form-control mt-4 sO submitNumber select2 goQN" style="height: unset !important;">
              <option value="undefined" disabled>Customer</option>
              <option *ngFor='let r of arreCustomer' [value]="r.id">{{r.name}}</option>
              </select><br>
              <select [(ngModel)]='customer_id' name="customer_id" class="form-control mt-4 sO submitNumber select2 goQN0" style="height: unset !important;">
                <option value="undefined" disabled>Seller</option>
                <option *ngFor='let r of arreCustomer00' [value]="r.id">{{r.name}}</option>
                </select>
                    <input *ngIf='add' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add">
                    <div style="clear: both;"></div>
                    </span>
                    </form>
                </div>
            </div>
        </div>
    </section>

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
        <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Delete confirmation">
        <div style="clear: both;"></div>
        </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data09oiu='ngForm' (submit)='okUp(data09oiu.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">

                      <label style="color: white;">Qty : </label>
                <input style='height:25px;' class="text mt-2 d1" type="number" name="qty" [(ngModel)]='qty' placeholder="Qty" required="">
                <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Return">
                  <div style="clear: both;"></div>
            </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd-upPAY0">
    <div class="main-w3layouts wrapper lastU" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUpPAY0()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data09oiuPAY='ngForm' (submit)='okUpPay(data09oiuPAY.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">

                      <label style="color: white;">Date : </label>
                      <input style='height: 25px;' class="text mt-2 d1" type="date" name="dateUpdate" [(ngModel)]='dateUpdate' placeholder="Add Money" required="" id="theDate">
                      <label style="color: white;" class="mt-2">Add Money : </label>
        <input style='height: 25px;' class="text mt-2 d1" type="number" name="payGoPAYUPDATE" [(ngModel)]='payGoPAYUPDATE' placeholder="Add Money" required="">
        <label style="color: white;" class="mt-2">Payment Way : </label>
        <select [(ngModel)]='PaymentWayPAYUPDATE' name="PaymentWayPAYUPDATE" class="form-control mt-2 sO" style="height: 25px !important;padding: 0  !important;">
          <option value='undefined' disabled selected>Payment Way</option>
          <option value='Cash' style="color: black !important;">Cash</option>
          <option value='Visa' style="color: black !important;">Visa</option>
          <option value='Check' style="color: black !important;">Check</option>
          </select>
        <label style="color: white;" class="mt-2">Notes : </label>
                            <input style="height: 25px;" class="text mt-2 d1 UpCha" type="text" name="NotesPAYUPDATE" [(ngModel)]='NotesPAYUPDATE' placeholder="Notes" required="">
        <input *ngIf='add' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Update">
                  <div style="clear: both;"></div>
            </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd-ddGoP">
    <div class="main-w3layouts wrapper lastU" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeddGoP()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data1020='ngForm' (submit)='Go12(data1020.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                      <label style="color: white;">Date : </label>
                      <input style='height: 25px;' class="text mt-2 d1" type="date" name="date" [(ngModel)]='date' placeholder="Add Money" required="" id="theDate">
                      <label style="color: white;" class="mt-2">Add Money : </label>
        <input style='height: 25px;' class="text mt-2 d1" type="number" name="payGo" [(ngModel)]='payGo' placeholder="Add Money" required="">
        <label style="color: white;" class="mt-2">Payment Way : </label>
        <select [(ngModel)]='PaymentWay' name="PaymentWay" class="form-control mt-2 sO" style="height: 25px !important;padding: 0  !important;">
          <option value='undefined' disabled selected>Payment Way</option>
          <option value='Cash' style="color: black !important;">Cash</option>
          <option value='Visa' style="color: black !important;">Visa</option>
          <option value='Check' style="color: black !important;">Check</option>
          </select>
          <label style="color: white;" class="mt-2">Image : </label>
          <input (click)='OrderDate00100()'  class="text mt-2 d1" type="text" placeholder="Images" required="" style="height: 25px;">
                              <input style="overflow: hidden !important; display: none !important;" id="im0" (change)='img($event)'  class="text mt-2 d1" type="file" accept="image/*" placeholder="الصور" required="" multiple>
                              <a *ngFor='let s of countImage; let x = index' id="but{{x}}"  class="but mt-2"><i class="fas fa-plus-circle"></i>
                                <img draggable="false" id="put44{{x}}" style="width: 100%; display: block; height: 100%;">
                              </a>
        <label style="color: white;" class="mt-2">Notes : </label>
                            <input style="height: 25px;" class="text mt-2 d1 UpCha" type="text" name="Notes" [(ngModel)]='Notes' placeholder="Notes" required="">
        <input *ngIf='add' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add">
        <div style="clear: both;"></div>
        </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd023" style="overflow-y: scroll;">
    <div class="card text-center m-5" style="padding: 10px;overflow-x: scroll;">
        <i (click)='close0093()' class="fas fa-times m-4" style="color: black; cursor: pointer; text-align: right;"></i>
        <button (click)='delSPay()' style='margin-top: auto;' class='btn btn-secondary mt-3' type="submit"><i class="fas fa-plus"></i></button>
        <table class="table table-striped table-sm" style="text-align: center; direction: ltr;">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Payment Way</th>
                    <th>Money</th>
                    <th>Image</th>
                    <th>Note</th>
                    <th>Update</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor='let v of arre0987; let n = index;'>
                    <td>{{v.date|date: 'dd-MM-yyyy'}}</td>
                    <td>{{v.waypay}}</td>
                    <td>{{v.money}}</td>
                    <td data-title="Photo" class='no'>
                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.image)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='v.image'>
                    </td>
                    <td>{{v.notes}}</td>
                    <td><button (click)='upP(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                </tr>
            </tbody>
        </table>
    </div>
    <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
</section>
<section id="upd-ddClose">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeddItem0()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
        <input (click)='okClose()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="تأكيد الغاء المنتج">
        <div style="clear: both;"></div>
        </span>
            </div>
        </div>
    </div>
</section>
<section id="updPho" style="text-align: center !important;">
    <button (click)='closePhot()' type="button" class="btn btn-danger m-4" style="box-shadow: none;display: inline;position: fixed;top: 0;left:0;z-index: 20000 !important;"><i class="fas fa-times " style="color: white; cursor: pointer;"></i></button>
    <div style="text-align: center !important; overflow: hidden !important;width: 100%;height: 100%;">
        <div style="display: inline-block; overflow: hidden !important;width: 100%;height: 100%;" id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" *ngIf='qwss' style="height: 100%;width: 100%;">
                <div class="carousel-item active" style="height: 100%;width: 100%;">
                    <img [src]="arrImage[0].url" class="d-block" alt="..." style='margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;'>
                </div>
                <div *ngFor='let f of arrImage|slice:1; let ff = index;' class="carousel-item" style="height: 100%;width: 100%;">
                    <img [src]="arrImage[ff + 1].url" class="d-block" alt="..." style='margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;'>
                </div>
            </div>
            <a style="margin:auto;margin-left:20px;display: inline-block;width: 40px;height: 40px; background-color:gray; border-radius:50%;" class="carousel-control-prev shadow-lg" href="#carouselExampleControls" role="button" data-slide="prev">
                <span style="margin-top: 25%;" class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a style="margin:auto;margin-right:20px;display: inline-block;width: 40px;height: 40px; background-color:gray; border-radius:50%;" class="carousel-control-next shadow-lg" href="#carouselExampleControls" role="button" data-slide="next">
                <span style="margin-top: 25%;" class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</section>
<section style="display: none !important;">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUpAnother()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data124009='ngForm' (submit)='okUpAnother(data124009.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
              <input  class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
              <input  class="text mt-2 d1" type="text" name="emailU" [(ngModel)]='emailU' placeholder="Email" required="">
              <input  class="text mt-2 d1" type="text" name="cityU" [(ngModel)]='cityU' placeholder="City" required="">
              <input  class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Adress" required="">
              <input  class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
              <input  class="text mt-2 d1" type="number" name="phone2U" [(ngModel)]='phone2U' placeholder="Phone 2" required="">
                <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Update">
                <div style="clear: both;"></div>
          </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd-upReturnback">
    <div class="main-w3layouts wrapper lastU" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUpreturnback()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data09oiu00='ngForm' (submit)='okreturnback(data09oiu00.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                      <label style="color: white;">Date : </label>
                          <input style='height: 25px;' class="text mt-2 d1" type="date" name="date0" [(ngModel)]='date0' placeholder="Add Money" required="" id="theDate0">

                    <label style="color: white;">Money : </label>
              <input style='height: 25px;' class="text mt-2 d1" type="number" name="money" [(ngModel)]='money' placeholder="Money" required="">
              <label style="color: white;" class="mt-2">Payment Way : </label>
        <select [(ngModel)]='PaymentWay' name="PaymentWay" class="form-control mt-2 sO" style="height: 25px !important;padding: 0  !important;">
          <option value='undefined' disabled selected>Payment Way</option>
          <option value='Cash' style="color: black !important;">Cash</option>
          <option value='Visa' style="color: black !important;">Visa</option>
          <option value='Check' style="color: black !important;">Check</option>
          </select>
          <label style="color: white;" class="mt-2">Notes : </label>
                            <input style="height: 25px;" class="text mt-2 d1 UpCha" type="text" name="Notes" [(ngModel)]='Notes' placeholder="Notes" required="">
              <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Return">
                <div style="clear: both;"></div>
          </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd-up00000d">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeup00000d()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data09oiu='ngForm' (submit)='items0Order()' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">

                    <label style="color: white;">Date : </label>
              <input style='height:25px;' class="text mt-2 d1" type="date" name="orerdate" [(ngModel)]='orerdate' placeholder="Qty" required="">
              <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Confirm">
                <div style="clear: both;"></div>
          </span>
                </form>
            </div>
        </div>
    </div>
</section>
<section id="upd-masrofat">
    <div class="main-w3layouts wrapper lastU" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeMsrouf()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data09oiu00Masr='ngForm' (submit)='okAccount(data09oiu00Masr.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                    <label style="color: white;">Date : </label>
                        <input style='height: 25px;' class="text mt-2 d1" type="date" name="date" [(ngModel)]='date' placeholder="Add Money" required="" id="theDate0">

                  <label style="color: white;">Money : </label>
            <input style='height: 25px;' class="text mt-2 d1" type="number" name="The_Amount" [(ngModel)]='The_Amount' placeholder="Money" required="">
        <label style="color: white;" class="mt-2">Notes : </label>
                          <input style="height: 25px;" class="text mt-2 d1 UpCha" type="text" name="Notes" [(ngModel)]='Notes' placeholder="Notes" required="">
            <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add">
              <div style="clear: both;"></div>
        </span>
                </form>
            </div>
        </div>
    </div>
</section>
